import { render, staticRenderFns } from "./UsdtAlert.vue?vue&type=template&id=d6ae6906&"
import script from "./UsdtAlert.vue?vue&type=script&lang=js&"
export * from "./UsdtAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports